import { add } from "./base";
class Handler {
    toString(data) {
        return typeof data == "string" ? data : "";
    }
    fromString(value) {
        return typeof value == "string" && !!value ? value : undefined;
    }
    partialFormat = this.format;
    format(unformatted) {
        return { ...unformatted, type: "password", autocomplete: "current-password" };
    }
    unformat(formatted) {
        return formatted;
    }
    allowed(symbol, state) {
        return true;
    }
}
add("password", () => new Handler());
//# sourceMappingURL=password.js.map